import {
  publish,
  publishSticky,
  subscribe,
  unsubscribe,
} from '@wh/message-bus';

interface DataType {
  topic: string;
  data: object;
}

const MessageBusBackend = {
  invoke: {
    publishEvent([data]: [DataType]) {
      publish({
        topic: data.topic,
        data: data.data,
      });
    },
    publishSticky([data]: [DataType]) {
      publishSticky(data.topic, data.data);
    },
  },
  on: {
    onSubscribe(callback: Function, args: string[]) {
      const subscriptions: string[] = [];
      args.forEach(topic => {
        const subscriptionId = subscribe(topic, (message, payload) => {
          return callback({ message, payload });
        });
        subscriptions.push(subscriptionId);
      });

      return () => {
        subscriptions.forEach(subscriptionId => unsubscribe(subscriptionId));
      };
    },
  },
};
export default MessageBusBackend;
